import { errorMessage } from "helpers/utils";
import { call, put, takeEvery } from "redux-saga/effects";
import VATManagerService from "services/VATManagerService";
import {
  activeVATManagerFail,
  activeVATManagerSuccess,
  createVATManagerFail,
  createVATManagerSuccess,
  detailVATManagerFail,
  detailVATManagerSuccess,
  listVATManagerFail,
  listVATManagerSuccess,
  updateVATManagerSuccess,
  updateVATManagerFail,
} from "store/actions";
import { deleteVATManagerFail, deleteVATManagerSuccess } from "./actions";
import {
  VAT_MANAGER_CREATE,
  VAT_MANAGER_DETAIL,
  VAT_MANAGER_LIST,
  VAT_MANAGER_UPDATE,
  VAT_MANAGER_DELETE
} from "./actionTypes";
function* fetchListVATManager({ payload }) {
  try {
    const response = yield call(VATManagerService.listVATManager, payload);
    yield put(listVATManagerSuccess(response));
  } catch (error) {
    yield put(listVATManagerFail(errorMessage(error)));
  }
}

function* onUpdateVATManager({ payload }) {
  try {
    const response = yield call(VATManagerService.updateVATManager, payload);
    yield put(updateVATManagerSuccess(response));
  } catch (error) {
    yield put(updateVATManagerFail(errorMessage(error)));
  }
}
function* onCreateVATManager({ payload }) {
  try {
    const response = yield call(VATManagerService.createVATManager, payload);
    yield put(createVATManagerSuccess(response));
  } catch (error) {
    yield put(createVATManagerFail(errorMessage(error)));
  }
}

function* onDetailVATManager({ payload }) {
  try {
    const response = yield call(VATManagerService.detailVATManager, payload);
    yield put(detailVATManagerSuccess(response));
  } catch (error) {
    yield put(detailVATManagerFail(errorMessage(error)));
  }
}

function* onDeleteVATManager({ payload }) {
  try {
    const response = yield call(VATManagerService.deleteVATManager, payload);
    yield put(deleteVATManagerSuccess(response));
  } catch (error) {
    yield put(deleteVATManagerFail(errorMessage(error)));
  }
}

function* onActiveVATManager({ payload }) {
  try {
    const response = yield call(VATManagerService.activeVATManager, payload);
    yield put(activeVATManagerSuccess(response));
  } catch (error) {
    yield put(activeVATManagerFail(errorMessage(error)));
  }
}

function* userManagementSaga() {
  yield takeEvery(VAT_MANAGER_LIST, fetchListVATManager);
  yield takeEvery(VAT_MANAGER_CREATE, onCreateVATManager);
  yield takeEvery(VAT_MANAGER_DETAIL, onDetailVATManager);
  yield takeEvery(VAT_MANAGER_UPDATE, onUpdateVATManager);
  yield takeEvery(VAT_MANAGER_DELETE, onDeleteVATManager);
}

export default userManagementSaga;
